import { UpdateProposalRequestDto } from '@modules/proposals/api/dto/updateProposal.dto';
import { legacyTypes } from '@modules/proposals/api/mappers/legacyTypes';
import { ProposalCreationClientAndMortgageForm } from '../types';
import { BUYOUT_TRANSACTION_TYPES, EQUITY_TRANSACTION_TYPES } from '..';

const normalizers = {
  equityReleaseAmount: (isEquityType: boolean, amount?: string) => {
    if (isEquityType && amount !== undefined) {
      return +amount;
    }

    return null;
  },
  existing_mortgage_type: (isAlreadyHaveMortgage: boolean, mortgageType?: string) => {
    if (isAlreadyHaveMortgage && mortgageType) {
      return legacyTypes.mortgageType[mortgageType];
    }

    return null;
  },
};

export const mapMortgageDetailsFormToRequest = (
  data: ProposalCreationClientAndMortgageForm
): UpdateProposalRequestDto['mortgage'] => {
  const isAlreadyHaveMortgage = BUYOUT_TRANSACTION_TYPES.includes(data.mortgage_details.transaction_type);
  const isEquityType = EQUITY_TRANSACTION_TYPES.includes(data.mortgage_details.transaction_type);

  return {
    mortgage_length: +data.mortgage_details.years * 12 + (+data.mortgage_details.months),
    downpayment: +data.mortgage_details.down_payment,
    downpayment_amount: +data.mortgage_details.downpayment_amount,
    loan_amount: +data.mortgage_details.loan_value,
    ltv: +data.mortgage_details.ltv,
    is_land_department_fee_financed: data.mortgage_details.is_land_department_fee_financed,
    is_real_estate_fee_financed: data.mortgage_details.is_real_estate_fee_financed,
    equity_release_amount: normalizers.equityReleaseAmount(isEquityType, data.mortgage_details.equity_release_amount),
    transaction_type: data.mortgage_details.transaction_type
      ? legacyTypes.transactionType[data.mortgage_details.transaction_type] : undefined,
    mortgage_type: data.mortgage_details.mortgage_type
      ? legacyTypes.mortgageType[data.mortgage_details.mortgage_type] : undefined,
    existing_mortgage_type: normalizers.existing_mortgage_type(
      isAlreadyHaveMortgage,
      data.mortgage_details.existing_mortgage_type
    ),
  };
};
